// @flow
import { APICore } from './apiCore';
import config from '../../config';
import { PAGINATION_DEFAULT_VALUE } from '../defaultValue';

const api = new APICore();

type Query = {
    currentPage: number,
    pageSize: number,
    search: string,
};

function getAllShipments(query: Query): any {    
    const page = query?.currentPage - 1 || PAGINATION_DEFAULT_VALUE.currentPage - 1;
    const page_size = query?.pageSize || PAGINATION_DEFAULT_VALUE.pageSize;

    let baseUrl = config.SHIPMENTS_URL;

    if (typeof query === 'string') {
        baseUrl += `?${query}`;
    }

    const queryParam = {
        page: page.toString(),
        page_size: page_size.toString(),
    };

    return api.get(`${baseUrl}`, typeof query === 'object' ? queryParam : undefined, {
        headers: { 'full-response': true },
    });
}

function getAllShipmentsReport(query: Query): any {
    let baseUrl = config.SHIPMENTS_URL + '/shipments_report';

    if (typeof query === 'string') {
        baseUrl += `?${query}`;
    }

    const queryParam = {};

    return api.get(`${baseUrl}`, typeof query === 'object' ? queryParam : undefined, {
        headers: { 'full-response': true },
    });
}

const getSiblingShipmentsUrl = (path) => config.SHIPMENTS_URL.replace(/\/shipments\/?$/, path);

function getShipmentSurcharges(query: Query): any {
    let baseUrl = getSiblingShipmentsUrl('/shipment_surcharges');

    if (typeof query === 'string') {
        baseUrl += `?${query}`;
    }

    return api.get(`${baseUrl}`, undefined, {
        headers: { 'full-response': true },
    });
}

function getNonShipmentSurcharges(query: Query): any {
    let baseUrl = getSiblingShipmentsUrl('/non_shipment_surcharges');

    if (typeof query === 'string') {
        baseUrl += `?${query}`;
    }

    return api.get(`${baseUrl}`, undefined, {
        headers: { 'full-response': true },
    });
}

function getShipmentByExternalOrderId(externalOrderId: string): any {
    return api.get(`${config.SHIPMENTS_URL}/external-order-id/${externalOrderId}`);
}

function rateShipments(query: Query): any {
    let baseUrl = config.SHIPMENTS_URL + '/rate';

    if (typeof query === 'string') {
        baseUrl += `?${query}`;
        return api.create(`${baseUrl}`, {});
    }

    return api.create(`${baseUrl}`, {}, { params: query || {} });
}

export {
    getAllShipments,
    getAllShipmentsReport,
    getShipmentByExternalOrderId,
    rateShipments,
    getShipmentSurcharges,
    getNonShipmentSurcharges,
};
